import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/devicesAdmin'

const devices = axios.create({
  baseURL
})

interceptorsSetup(devices)

export default class Device {
  static async resetDevice (code) {
    const { data: result } = await devices.get(`/${code}/reset`)
    return result
  }

  static async getMvtTypes () {
    const { data: result } = await devices.get('/mvt-type')
    return result
  }

  static async getDeviceConfig (uuid) {
    const { data: result } = await devices.get(`/device-config/${uuid}`)
    return result
  }

  static async updateDeviceConfig (uuid, config) {
    const { data: result } = await devices.put(`/device-config/${uuid}`, config)
    return result
  }
}
